(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 23935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(35635);
// EXTERNAL MODULE: ./src/pages/404.tsx + 2 modules
var _404 = __webpack_require__(34340);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./src/store/reducers/tager/pages.ts
var pages = __webpack_require__(55724);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(69447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(30172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(95186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/components/navigation/navigation.min.css
var navigation_min = __webpack_require__(66539);
// EXTERNAL MODULE: ./src/components/Spinner/index.ts + 1 modules
var Spinner = __webpack_require__(66595);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/Home/components/Slider/Slider.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















core_class/* default.use */.Z.use([navigation/* default */.Z, autoplay/* default */.Z]);

function Slider() {
  const {
    0: mounted,
    1: setMounted
  } = (0,react.useState)(false);
  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    bannersMain
  } = page === null || page === void 0 ? void 0 : page.templateFields;
  (0,react.useEffect)(() => {
    setMounted(true);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: !mounted ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : bannersMain && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
      loop: true,
      navigation: true,
      slidesPerView: 1,
      speed: 500,
      autoplay: {
        delay: 8000
      },
      children: bannersMain.map(({
        title,
        text,
        image,
        url,
        background
      }, index) => {
        console.log((0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image));
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
            background: background,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
              to: url,
              children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread(_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image)), {}, {
                alt: title
              }))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Description, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
                empty: !!image || background !== '#000000',
                children: title
              }), text && /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
                empty: !!image || background !== '#000000',
                children: text
              })]
            })]
          })
        }, (title !== null && title !== void 0 ? title : '') + index);
      })
    })
  });
}

const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Slider__Component",
  componentId: "sc-4bpd3-0"
})(["height:53.03vh;min-height:250px;position:relative;max-width:1024px;margin:0 auto;filter:drop-shadow(0px 4px 4px rgba(0,0,0,0.25));@media (orientation:landscape){height:80.03vh;}@media (min-width:", "px){height:350px;}@media (min-width:", "px){height:500px;}.swiper-container{height:100%;}"], theme/* breakpoints.mobileLarge */.AV.mobileLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Slider__Content",
  componentId: "sc-4bpd3-1"
})(["position:relative;height:100%;background-color:", ";"], ({
  background
}) => background);
const StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).withConfig({
  displayName: "Slider__StyledLink",
  componentId: "sc-4bpd3-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;"]);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "Slider__StyledPicture",
  componentId: "sc-4bpd3-3"
})(["width:100%;height:100%;picture,img{width:100%;height:100%;}img{width:100%;height:100%;object-fit:cover;object-position:bottom;@media (min-width:", "px){}}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Slider__Description",
  componentId: "sc-4bpd3-4"
})(["padding:40px 15px 0;text-align:center;position:relative;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Slider__Title",
  componentId: "sc-4bpd3-5"
})(["font-style:normal;font-weight:600;font-size:22px;line-height:30px;color:", ";@media (min-width:", "px){font-size:26px;}"], ({
  empty
}) => empty ? '#000' : '#fff', theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const SubTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Slider__SubTitle",
  componentId: "sc-4bpd3-6"
})(["font-weight:500;font-size:18px;line-height:30px;@media (min-width:", "px){font-size:22px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
/* harmony default export */ var Slider_Slider = (Slider);
;// CONCATENATED MODULE: ./src/modules/Home/components/Slider/index.ts

// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
;// CONCATENATED MODULE: ./src/modules/Home/components/Cards/CardItem/CardItem.tsx


function CardItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CardItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CardItem_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CardItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











function CardItem({
  title,
  image,
  text
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CardItem_Description, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardItem_Title, {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem_SubTitle, {
          children: text
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageBody, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, CardItem_objectSpread(CardItem_objectSpread({
            loading: 'lazy'
          }, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image)), {}, {
            alt: title
          }))
        })
      })]
    })
  });
}

/* harmony default export */ var CardItem_CardItem = (CardItem);
const CardItem_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__Component",
  componentId: "sc-866la4-0"
})(["background-color:", ";padding:27px 0;& > div{display:flex;align-items:center;justify-content:space-between;}"], theme/* colors.grayCart */.O9.grayCart);
const ImageContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__ImageContainer",
  componentId: "sc-866la4-1"
})(["display:inline-block;position:relative;picture{width:100%;height:100%;}}img{height:75px;object-fit:contain;@media (min-width:", "px){height:90px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const ImageBody = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__ImageBody",
  componentId: "sc-866la4-2"
})(["& > div{width:100%;height:100%;justify-content:flex-end;}"]);
const CardItem_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__Title",
  componentId: "sc-866la4-3"
})(["font-style:normal;font-weight:500;font-size:20px;line-height:30px;@media (min-width:", "px){font-size:24px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const CardItem_Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__Description",
  componentId: "sc-866la4-4"
})(["display:inline-block;flex:0 1 55%;"]);
const CardItem_SubTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardItem__SubTitle",
  componentId: "sc-866la4-5"
})(["font-style:normal;font-weight:500;font-size:11px;line-height:18px;@media (min-width:", "px){font-size:14px;line-height:22px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
;// CONCATENATED MODULE: ./src/modules/Home/components/Cards/CardItem/index.ts

;// CONCATENATED MODULE: ./src/modules/Home/components/Cards/Cards.tsx







function Cards() {
  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    bannersSidebar
  } = page === null || page === void 0 ? void 0 : page.templateFields;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cards_Component, {
    children: bannersSidebar.map(({
      title,
      image,
      text,
      url
    }, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      to: url,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem_CardItem, {
        image: image,
        title: title,
        text: text
      })
    }, index + (title !== null && title !== void 0 ? title : '')))
  });
}

/* harmony default export */ var Cards_Cards = (Cards);
const Cards_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Cards__Component",
  componentId: "sc-1bd4e57-0"
})(["width:100%;min-height:120px;padding-top:12px;& > a:last-child{display:block;margin-top:7px;}"]);
;// CONCATENATED MODULE: ./src/modules/Home/components/Cards/index.ts

;// CONCATENATED MODULE: ./src/modules/Home/components/Catalog/components/CatalogCard/CatalogCard.tsx


function CatalogCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CatalogCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CatalogCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CatalogCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function CatalogCard({
  image,
  label,
  url,
  isCatalog
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogCard_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, {
      to: url,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, CatalogCard_objectSpread(CatalogCard_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image)), {}, {
          alt: label !== null && label !== void 0 ? label : '',
          catalog: isCatalog
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        catalog: isCatalog,
        children: label
      })]
    })
  });
}

/* harmony default export */ var CatalogCard_CatalogCard = (CatalogCard);
const CatalogCard_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCard__Component",
  componentId: "sc-zpwmcp-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:center;width:100%;padding:0 17px;border-radius:6px;background-color:", ";& > a{width:100%;height:100%;}"], theme/* colors.grayCart */.O9.grayCart);
const Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCard__Body",
  componentId: "sc-zpwmcp-1"
})(["margin-top:16px;"]);
const Image = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "CatalogCard__Image",
  componentId: "sc-zpwmcp-2"
})(["width:", ";height:64px;margin:0 auto;picture{width:100%;height:100%;}img{width:100%;height:100%;object-fit:contain;}"], ({
  catalog
}) => catalog ? '90px' : '64px');
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCard__Label",
  componentId: "sc-zpwmcp-3"
})(["text-align:center;font-size:13px;line-height:40px;font-weight:600;color:", ";@media (min-width:768px){font-size:15px;}"], ({
  catalog
}) => catalog ? theme/* colors.darkRed */.O9.darkRed : theme/* colors.black */.O9.black);
;// CONCATENATED MODULE: ./src/modules/Home/components/Catalog/components/CatalogCard/index.ts

;// CONCATENATED MODULE: ./src/modules/Home/components/Catalog/Catalog.tsx


function Catalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Catalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Catalog_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Catalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











function Catalog() {
  const {
    templateFields: {
      catalogTitle,
      catalogMobileItems
    }
  } = (0,hooks/* useCurrentPage */.Wo)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Title, {
        children: catalogTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Content, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
          children: catalogMobileItems.map((card, index) => /*#__PURE__*/(0,react.createElement)(CatalogCard_CatalogCard, Catalog_objectSpread(Catalog_objectSpread({}, card), {}, {
            key: index
          })))
        })
      })]
    })
  });
}

const Catalog_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Component",
  componentId: "sc-q23b4e-0"
})(["padding-top:4px;"]);
const Catalog_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Title",
  componentId: "sc-q23b4e-1"
})(["font-style:normal;font-weight:500;font-size:22px;line-height:40px;@media (min-width:", "){font-size:24px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Catalog_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Content",
  componentId: "sc-q23b4e-2"
})([""]);
const List = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__List",
  componentId: "sc-q23b4e-3"
})(["display:grid;grid-template-columns:calc(50% - 5px) calc(50% - 5px);justify-items:center;gap:10px;}"]);
/* harmony default export */ var Catalog_Catalog = (Catalog);
;// CONCATENATED MODULE: ./src/modules/Home/components/Catalog/index.ts

// EXTERNAL MODULE: ./node_modules/swiper/components/pagination/pagination.min.css
var pagination_min = __webpack_require__(97735);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/ProductCard/index.ts + 1 modules
var ProductCard = __webpack_require__(50819);
// EXTERNAL MODULE: ./src/store/reducers/pages/products.ts
var products = __webpack_require__(13006);
// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
;// CONCATENATED MODULE: ./src/modules/Home/components/TopSells/TopSells.tsx


function TopSells_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TopSells_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TopSells_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TopSells_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















core_class/* default.use */.Z.use([navigation/* default */.Z]);

function TopSells() {
  const {
    data
  } = (0,store/* useTypedSelector */.ix)(state => (0,products/* selectProductListByGroupResource */.yv)(state, 'TOP'));
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TopSells_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopSells_Title, {
        children: t('sale_hits')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Nav, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Prev, {
          className: "prev"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Next, {
          className: "next"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TopSells_Body, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TopSells_Content, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
          navigation: {
            prevEl: '.prev',
            nextEl: '.next'
          },
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          spaceBetween: 15,
          slidesPerView: 1.25,
          loop: true,
          slidesPerGroup: 1,
          breakpoints: {
            500: {
              slidesPerView: 2.2
            }
          },
          children: data === null || data === void 0 ? void 0 : data.map(props => {
            var _props$image;

            return (props === null || props === void 0 ? void 0 : (_props$image = props.image) === null || _props$image === void 0 ? void 0 : _props$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                to: '/products/' + props.urlAlias,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard/* default */.Z, TopSells_objectSpread({}, props))
              })
            }, props.id);
          })
        })
      })
    })]
  });
}

/* harmony default export */ var TopSells_TopSells = (TopSells);
const TopSells_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Component",
  componentId: "sc-m9s33v-0"
})(["margin-top:17px;"]);
const Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Header",
  componentId: "sc-m9s33v-1"
})(["padding:0 15px;margin-bottom:5px;display:flex;align-items:center;justify-content:space-between;"]);
const Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Nav",
  componentId: "sc-m9s33v-2"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Prev",
  componentId: "sc-m9s33v-3"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Next",
  componentId: "sc-m9s33v-4"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const TopSells_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Title",
  componentId: "sc-m9s33v-5"
})(["font-weight:500;font-size:22px;line-height:40px;@media (min-width:", "px){font-size:24px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const TopSells_Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Body",
  componentId: "sc-m9s33v-6"
})([""]);
const TopSells_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopSells__Content",
  componentId: "sc-m9s33v-7"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Home/components/TopSells/index.ts

;// CONCATENATED MODULE: ./src/modules/Home/components/Arrivals/Arrivals.tsx


function Arrivals_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Arrivals_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Arrivals_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Arrivals_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















core_class/* default.use */.Z.use([navigation/* default */.Z]);

function Arrivals() {
  const {
    data
  } = (0,store/* useTypedSelector */.ix)(state => (0,products/* selectProductListByGroupResource */.yv)(state, 'NEW'));
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Arrivals_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Arrivals_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Title, {
        children: t('catalog.new')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Arrivals_Nav, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Prev, {
          className: "prev-arrivals"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Next, {
          className: "next-arrivals"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Body, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Content, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
          navigation: {
            prevEl: '.prev-arrivals',
            nextEl: '.next-arrivals'
          },
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          spaceBetween: 15,
          slidesPerView: 1.25,
          loop: true,
          slidesPerGroup: 1,
          breakpoints: {
            500: {
              slidesPerView: 2.2
            }
          },
          children: data === null || data === void 0 ? void 0 : data.map(props => {
            var _props$image;

            return (props === null || props === void 0 ? void 0 : (_props$image = props.image) === null || _props$image === void 0 ? void 0 : _props$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                to: '/products/' + props.urlAlias,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard/* default */.Z, Arrivals_objectSpread({}, props))
              })
            }, props.id);
          })
        })
      })
    })]
  });
}

const Arrivals_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Component",
  componentId: "sc-1bm3cdo-0"
})(["margin-top:17px;"]);
const Arrivals_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Content",
  componentId: "sc-1bm3cdo-1"
})([""]);
const Arrivals_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Title",
  componentId: "sc-1bm3cdo-2"
})(["font-weight:500;font-size:22px;line-height:40px;@media (min-width:", "px;){font-size:24px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Arrivals_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Header",
  componentId: "sc-1bm3cdo-3"
})(["padding:0 15px;margin-bottom:5px;display:flex;align-items:center;justify-content:space-between;"]);
const Arrivals_Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Nav",
  componentId: "sc-1bm3cdo-4"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Arrivals_Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Prev",
  componentId: "sc-1bm3cdo-5"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Arrivals_Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Next",
  componentId: "sc-1bm3cdo-6"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Arrivals_Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Arrivals__Body",
  componentId: "sc-1bm3cdo-7"
})([""]);
/* harmony default export */ var Arrivals_Arrivals = (Arrivals);
;// CONCATENATED MODULE: ./src/modules/Home/components/Arrivals/index.ts

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./src/store/reducers/tager/blog.ts
var blog = __webpack_require__(44272);
// EXTERNAL MODULE: ./src/components/PlainPostCard/index.ts + 1 modules
var PlainPostCard = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/modules/Home/components/Blog/Blog.tsx













core_class/* default.use */.Z.use([navigation/* default */.Z]);

function Blog() {
  const {
    templateFields
  } = (0,hooks/* useCurrentPage */.Wo)();
  const posts = (0,es/* useSelector */.v9)(blog/* selectBlogPostListResource */.bx);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Blog_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Blog_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Title, {
        children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.blogTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Blog_Nav, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Prev, {
          className: "prev-blog"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Next, {
          className: "next-blog"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Content, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
          navigation: {
            prevEl: '.prev-blog',
            nextEl: '.next-blog'
          },
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          spaceBetween: 15,
          slidesPerView: 1.25,
          loop: true,
          slidesPerGroup: 1,
          breakpoints: {
            576: {
              slidesPerView: 2.2
            }
          },
          children: posts.data.map(post => /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: '/blog/' + post.urlAlias,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlainPostCard/* default */.Z, {
                post: post
              })
            })
          }, post.id))
        })
      })
    })]
  });
}

/* harmony default export */ var Blog_Blog = (Blog);
const Blog_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Header",
  componentId: "sc-1gthdou-0"
})(["padding:0 15px;margin-bottom:5px;display:flex;align-items:center;justify-content:space-between;"]);
const Blog_Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Nav",
  componentId: "sc-1gthdou-1"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Blog_Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Prev",
  componentId: "sc-1gthdou-2"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Blog_Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Next",
  componentId: "sc-1gthdou-3"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Blog_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Component",
  componentId: "sc-1gthdou-4"
})(["margin-top:17px;"]);
const Blog_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Title",
  componentId: "sc-1gthdou-5"
})(["font-style:normal;font-weight:500;font-size:22px;line-height:40px;@media (min-width:", "px){font-size:24px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Blog_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Content",
  componentId: "sc-1gthdou-6"
})(["margin:0 -15px;"]);
;// CONCATENATED MODULE: ./src/modules/Home/components/Blog/index.ts

// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
;// CONCATENATED MODULE: ./src/modules/Home/Home.tsx












function Home() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Home_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Slider_Slider, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Cards_Cards, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Catalog, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(TopSells_TopSells, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrivals_Arrivals, {}), (0,common/* getCurrentProject */.vo)() !== 'dveri' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Blog, {}) : null]
  });
}

const Home_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Home__Component",
  componentId: "sc-6ozan2-0"
})([""]);
/* harmony default export */ var Home_Home = (Home);
;// CONCATENATED MODULE: ./src/modules/Home/index.ts

// EXTERNAL MODULE: ./src/hooks/useCurrentPage.ts
var useCurrentPage = __webpack_require__(47715);
;// CONCATENATED MODULE: ./src/modules/DveriDefaultTemplate.tsx







function DveriDefaultTemplate() {
  const page = (0,useCurrentPage/* useCurrentPage */.W)();
  if (!page) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DveriDefaultTemplate_Component, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DveriDefaultTemplate_Title, {
        children: page.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DveriDefaultTemplate_Content, {
        dangerouslySetInnerHTML: {
          __html: page.body || ''
        }
      })]
    })
  });
}

const DveriDefaultTemplate_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriDefaultTemplate__Component",
  componentId: "sc-e8tmm4-0"
})(["margin:40px 0 70px;"]);
const DveriDefaultTemplate_Title = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "DveriDefaultTemplate__Title",
  componentId: "sc-e8tmm4-1"
})(["font-size:40px;"]);
const DveriDefaultTemplate_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriDefaultTemplate__Content",
  componentId: "sc-e8tmm4-2"
})(["font-size:24px;line-height:36px;max-width:1200px;.image-style-side{float:right;margin:20px 0 20px 20px;}p{margin-bottom:20px;}h2,h3{margin:40px 0 20px;font-size:32px;}strong{font-weight:bold;}"]);
/* harmony default export */ var modules_DveriDefaultTemplate = (DveriDefaultTemplate);
;// CONCATENATED MODULE: ./src/modules/DefaultTemplate.tsx


function DefaultTemplate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DefaultTemplate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DefaultTemplate_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DefaultTemplate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function DefaultTemplate(props) {
  var _page$body;

  const page = (0,useCurrentPage/* useCurrentPage */.W)();
  const projectName = (0,common/* getCurrentProject */.vo)();

  if (projectName === 'DVERI') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(modules_DveriDefaultTemplate, DefaultTemplate_objectSpread({}, props));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        children: page === null || page === void 0 ? void 0 : page.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: (_page$body = page === null || page === void 0 ? void 0 : page.body) !== null && _page$body !== void 0 ? _page$body : ''
        }
      })]
    })
  });
}

const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DefaultTemplate__Container",
  componentId: "sc-1kzvnmq-0"
})(["max-width:1200px;margin:20px auto;"]);
/* harmony default export */ var modules_DefaultTemplate = (DefaultTemplate);
// EXTERNAL MODULE: ./src/components/BreadCrumb/index.ts + 2 modules
var BreadCrumb = __webpack_require__(3601);
// EXTERNAL MODULE: ./src/components/SocialMediaLink/index.ts + 4 modules
var SocialMediaLink = __webpack_require__(12199);
// EXTERNAL MODULE: ./src/assets/svg/Footer/Map.point.icon/Map.point.logo.svg
var Map_point_logo = __webpack_require__(37040);
;// CONCATENATED MODULE: ./src/assets/svg/clock.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.99972C0 3.58867 3.58878 -0.000244141 8.00001 -0.000244141C12.4112 -0.000244141 16 3.58867 16 7.99972C16 12.4109 12.4112 15.9997 8.00001 15.9997C3.58878 15.9997 0 12.4109 0 7.99972ZM2.00003 7.99972C2.00003 11.3133 4.68626 13.9997 8.00001 13.9997C11.3137 13.9997 13.9999 11.3133 13.9999 7.99972C13.9999 4.68599 11.3137 1.99975 8.00001 1.99975C4.68626 1.99975 2.00003 4.68599 2.00003 7.99972ZM9.00003 6.99968H11C11.5527 6.99968 11.9999 7.44745 11.9999 7.99972C11.9999 8.55188 11.5527 8.99979 11 8.99979H8.00001C7.44775 8.99979 7.00007 8.55188 7.00007 7.99972V4.99968C7.00007 4.44752 7.44775 3.99975 8.00001 3.99975C8.55217 3.99975 9.00003 4.44752 9.00003 4.99968V6.99968Z",
  fill: "#860935"
});

function SvgClock({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var clock = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDcuOTk5NzJDMCAzLjU4ODY3IDMuNTg4NzggLTAuMDAwMjQ0MTQxIDguMDAwMDEgLTAuMDAwMjQ0MTQxQzEyLjQxMTIgLTAuMDAwMjQ0MTQxIDE2IDMuNTg4NjcgMTYgNy45OTk3MkMxNiAxMi40MTA5IDEyLjQxMTIgMTUuOTk5NyA4LjAwMDAxIDE1Ljk5OTdDMy41ODg3OCAxNS45OTk3IDAgMTIuNDEwOSAwIDcuOTk5NzJaTTIuMDAwMDMgNy45OTk3MkMyLjAwMDAzIDExLjMxMzMgNC42ODYyNiAxMy45OTk3IDguMDAwMDEgMTMuOTk5N0MxMS4zMTM3IDEzLjk5OTcgMTMuOTk5OSAxMS4zMTMzIDEzLjk5OTkgNy45OTk3MkMxMy45OTk5IDQuNjg1OTkgMTEuMzEzNyAxLjk5OTc1IDguMDAwMDEgMS45OTk3NUM0LjY4NjI2IDEuOTk5NzUgMi4wMDAwMyA0LjY4NTk5IDIuMDAwMDMgNy45OTk3MlpNOS4wMDAwMyA2Ljk5OTY4SDExQzExLjU1MjcgNi45OTk2OCAxMS45OTk5IDcuNDQ3NDUgMTEuOTk5OSA3Ljk5OTcyQzExLjk5OTkgOC41NTE4OCAxMS41NTI3IDguOTk5NzkgMTEgOC45OTk3OUg4LjAwMDAxQzcuNDQ3NzUgOC45OTk3OSA3LjAwMDA3IDguNTUxODggNy4wMDAwNyA3Ljk5OTcyVjQuOTk5NjhDNy4wMDAwNyA0LjQ0NzUyIDcuNDQ3NzUgMy45OTk3NSA4LjAwMDAxIDMuOTk5NzVDOC41NTIxNyAzLjk5OTc1IDkuMDAwMDMgNC40NDc1MiA5LjAwMDAzIDQuOTk5NjhWNi45OTk2OFoiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==");

// EXTERNAL MODULE: ./node_modules/react-yandex-maps/dist/production/react-yandex-maps.esm.js
var react_yandex_maps_esm = __webpack_require__(38112);
;// CONCATENATED MODULE: ./src/components/YandexMap/YandexMap.tsx





const defaultCenter = [53.923, 27.443];

function YandexMap({
  center,
  zoom = 9,
  pins
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(YandexMap_Content, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_yandex_maps_esm/* YMaps */.Yy, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(react_yandex_maps_esm/* Map */.D5, {
        width: '100%',
        height: '100%',
        state: {
          center: center || defaultCenter,
          zoom
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_yandex_maps_esm/* ZoomControl */.Ly, {}), pins === null || pins === void 0 ? void 0 : pins.map(pin => /*#__PURE__*/(0,jsx_runtime.jsx)(react_yandex_maps_esm/* Placemark */.ah, {
          modules: ['geoObject.addon.balloon', 'geoObject.addon.hint'],
          geometry: pin.coordinates,
          options: {
            preset: 'islands#redDotIcon'
          },
          properties: {
            hintContent: pin.hint,
            balloonContent: pin.balloon
          }
        }, pin.coordinates.join('_')))]
      })
    })
  });
}

const YandexMap_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "YandexMap__Content",
  componentId: "sc-1izb38g-0"
})(["position:absolute;left:0;right:0;top:0;bottom:0;z-index:0;"]);
/* harmony default export */ var YandexMap_YandexMap = (YandexMap);
;// CONCATENATED MODULE: ./src/components/YandexMap/index.ts

// EXTERNAL MODULE: ./src/components/A1/index.ts
var A1 = __webpack_require__(18176);
// EXTERNAL MODULE: ./src/components/Mts/index.ts + 2 modules
var Mts = __webpack_require__(38365);
;// CONCATENATED MODULE: ./src/modules/Contacts/components/Phones/Phones.tsx







function Phones({
  reference
}) {
  const {
    a1,
    mts
  } = reference;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Phones_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(A1/* default */.Z, {
      title: a1
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Mts/* default */.Z, {
      title: mts
    })]
  });
}

const Phones_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Phones__Component",
  componentId: "sc-ql4457-0"
})(["margin-top:15px;"]);
/* harmony default export */ var Phones_Phones = (Phones);
;// CONCATENATED MODULE: ./src/modules/Contacts/components/Phones/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/mail.svg
function mail_extends() { mail_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }



var mail_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H14C15.1 12 16 11.1 16 10V2C16 0.9 15.1 0 14 0ZM12.4 2L8 5.7L3.6 2H12.4ZM14 10H2V3.3L7.4 7.8C7.5 7.9 7.8 8 8 8C8.2 8 8.5 7.9 8.6 7.8L14 3.3V10Z",
  fill: "#860935"
});

function SvgMail({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", mail_extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, mail_ref);
}

/* harmony default export */ var mail = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAwSDJDMC45IDAgMCAwLjkgMCAyVjEwQzAgMTEuMSAwLjkgMTIgMiAxMkgxNEMxNS4xIDEyIDE2IDExLjEgMTYgMTBWMkMxNiAwLjkgMTUuMSAwIDE0IDBaTTEyLjQgMkw4IDUuN0wzLjYgMkgxMi40Wk0xNCAxMEgyVjMuM0w3LjQgNy44QzcuNSA3LjkgNy44IDggOCA4QzguMiA4IDguNSA3LjkgOC42IDcuOEwxNCAzLjNWMTBaIiBmaWxsPSIjODYwOTM1Ii8+Cjwvc3ZnPgo=");

;// CONCATENATED MODULE: ./src/modules/Contacts/components/Email/Email.tsx







function Email({
  reference
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Email_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, {
      to: `mailto:${reference}`,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Email_Title, {
        children: reference
      })]
    })
  });
}

/* harmony default export */ var Email_Email = (Email);
const Email_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Email__Component",
  componentId: "sc-cw3pxa-0"
})(["margin-top:29px;& > a{display:flex;align-items:center;}"]);
const StyledIcon = (0,styled_components_browser_esm["default"])(SvgMail).withConfig({
  displayName: "Email__StyledIcon",
  componentId: "sc-cw3pxa-1"
})(["margin-right:15px;"]);
const Email_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Email__Title",
  componentId: "sc-cw3pxa-2"
})(["font-weight:500;font-size:18px;line-height:24px;"]);
;// CONCATENATED MODULE: ./src/modules/Contacts/components/Email/index.ts

;// CONCATENATED MODULE: ./src/modules/Contacts/Contacts.tsx


function Contacts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Contacts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Contacts_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Contacts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















function getCoordinates(coordinates) {
  if (!coordinates) return null;
  return Object.values(coordinates);
}

function Contacts() {
  var _page$templateFields$, _page$templateFields, _page$templateFields$2, _page$templateFields2, _page$templateFields3, _page$templateFields4, _pageFields$gallery;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const a1 = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_A1');
  const mts = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_MTS');
  const email = (0,hooks/* useSettingItem */.qT)('CONTACTS_EMAIL');
  const viber = (0,hooks/* useSettingItem */.qT)('CONTACTS_VIBER');
  const whatsUp = (0,hooks/* useSettingItem */.qT)('CONTACTS_WHATSAPP');
  const telegram = (0,hooks/* useSettingItem */.qT)('CONTACTS_TELEGRAM');
  const text = (0,hooks/* useSettingItem */.qT)('CONTACTS_CALL_TO_ACTION');
  const pageFields = page === null || page === void 0 ? void 0 : page.templateFields;
  const coordinates = getCoordinates(pageFields === null || pageFields === void 0 ? void 0 : pageFields.map);
  const breadCrumbs = [];

  if (page) {
    breadCrumbs.push({
      label: page.title,
      url: page.path
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeader, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
          breadCrumbs: breadCrumbs
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Contacts_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Title, {
          children: page.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Phones_Phones, {
          reference: {
            a1,
            mts
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActionText, {
            children: text
          })
        }), email && /*#__PURE__*/(0,jsx_runtime.jsx)(Email_Email, {
          reference: email
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SocialMediaWrapper, {
          children: [viber && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
            type: "Viber",
            reference: viber
          }), whatsUp && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
            type: "WhatsUp",
            reference: whatsUp
          }), telegram && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
            type: "Telegram",
            reference: telegram
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MapWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MapTitle, {
            children: (_page$templateFields$ = page === null || page === void 0 ? void 0 : (_page$templateFields = page.templateFields) === null || _page$templateFields === void 0 ? void 0 : _page$templateFields.mapTitle) !== null && _page$templateFields$ !== void 0 ? _page$templateFields$ : ''
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MapShopTitle, {
            children: (_page$templateFields$2 = page === null || page === void 0 ? void 0 : (_page$templateFields2 = page.templateFields) === null || _page$templateFields2 === void 0 ? void 0 : _page$templateFields2.mapShopTitle) !== null && _page$templateFields$2 !== void 0 ? _page$templateFields$2 : ''
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Location, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledMapIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Description, {
              children: (_page$templateFields3 = page.templateFields) === null || _page$templateFields3 === void 0 ? void 0 : _page$templateFields3.mapAddress
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(WorkTime, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledClock, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Description, {
              children: (_page$templateFields4 = page.templateFields) === null || _page$templateFields4 === void 0 ? void 0 : _page$templateFields4.mapWorkTime
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(YandexMap_YandexMap, {
              center: coordinates,
              zoom: 15,
              pins: coordinates ? [{
                coordinates
              }] : undefined
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MapHowTo, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Title, {
              children: pageFields === null || pageFields === void 0 ? void 0 : pageFields.mapHowToTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MapHowToText, {
              dangerouslySetInnerHTML: {
                __html: pageFields === null || pageFields === void 0 ? void 0 : pageFields.mapHowToText
              }
            }), ((_pageFields$gallery = pageFields === null || pageFields === void 0 ? void 0 : pageFields.gallery) !== null && _pageFields$gallery !== void 0 ? _pageFields$gallery : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, Contacts_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureImage */.iS)(item)), index))]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InvoiceDetails, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Title, {
              children: pageFields === null || pageFields === void 0 ? void 0 : pageFields.legalTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlainText, {
              dangerouslySetInnerHTML: {
                __html: pageFields === null || pageFields === void 0 ? void 0 : pageFields.legalText
              }
            })]
          })]
        })]
      })]
    })
  });
}

const Contacts_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Component",
  componentId: "sc-1f50ifc-0"
})([""]);
const PageHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__PageHeader",
  componentId: "sc-1f50ifc-1"
})([""]);
const Contacts_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Title",
  componentId: "sc-1f50ifc-2"
})(["font-weight:500;font-size:18px;line-height:24px;"]);
const Contacts_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Content",
  componentId: "sc-1f50ifc-3"
})([""]);
const CallToAction = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__CallToAction",
  componentId: "sc-1f50ifc-4"
})(["margin-top:18px;display:flex;align-items:center;justify-content:center;height:34px;background:", ";border-radius:5px;"], theme/* colors.gray237 */.O9.gray237);
const ActionText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Contacts__ActionText",
  componentId: "sc-1f50ifc-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:18px;"]);
const SocialMediaWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__SocialMediaWrapper",
  componentId: "sc-1f50ifc-6"
})(["margin-top:29px;display:flex;& > div:not(:last-child){margin-right:12px;}"]);
const HighLight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__HighLight",
  componentId: "sc-1f50ifc-7"
})(["display:inline-block;font-style:normal;font-weight:600;font-size:12px;line-height:20px;color:", ";"], theme/* colors.darkRed */.O9.darkRed);
const mapDescriptionCss = (0,styled_components_browser_esm.css)(["font-weight:500;font-size:18px;line-height:24px;"]);
const flexStart = (0,styled_components_browser_esm.css)(["display:flex;align-items:flex-start;"]);
const MapWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__MapWrapper",
  componentId: "sc-1f50ifc-8"
})([""]);
const MapTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__MapTitle",
  componentId: "sc-1f50ifc-9"
})(["margin-top:37px;", ""], mapDescriptionCss);
const MapShopTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__MapShopTitle",
  componentId: "sc-1f50ifc-10"
})(["margin-top:6px;", ""], mapDescriptionCss);
const Location = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Location",
  componentId: "sc-1f50ifc-11"
})(["margin-top:12px;& > *:first-child{margin-top:5px;margin-right:12px;}", ""], flexStart);
const WorkTime = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__WorkTime",
  componentId: "sc-1f50ifc-12"
})(["margin-top:15px;& > *:first-child{margin-right:12px;margin-top:5px;}", ""], flexStart);
const Contacts_Description = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Contacts__Description",
  componentId: "sc-1f50ifc-13"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"]);
const StyledMapIcon = (0,styled_components_browser_esm["default"])(Map_point_logo/* ReactComponent */.r).withConfig({
  displayName: "Contacts__StyledMapIcon",
  componentId: "sc-1f50ifc-14"
})(["min-width:16px;min-height:16px;"]);
const StyledClock = (0,styled_components_browser_esm["default"])(SvgClock).withConfig({
  displayName: "Contacts__StyledClock",
  componentId: "sc-1f50ifc-15"
})(["min-width:16px;min-height:16px;"]);
const Map = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Map",
  componentId: "sc-1f50ifc-16"
})(["margin-top:15px;position:relative;height:320px;"]);
const MapHowTo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__MapHowTo",
  componentId: "sc-1f50ifc-17"
})(["margin-top:22px;& > picture:first-child{}"]);
const MapHowToText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__MapHowToText",
  componentId: "sc-1f50ifc-18"
})(["margin-top:9px;"]);
const InvoiceDetails = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__InvoiceDetails",
  componentId: "sc-1f50ifc-19"
})(["margin-top:25px;"]);
const PlainText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__PlainText",
  componentId: "sc-1f50ifc-20"
})(["margin-top:7px;font-style:normal;font-weight:normal;font-size:12px;line-height:20px;"]);
/* harmony default export */ var Contacts_Contacts = (Contacts);
;// CONCATENATED MODULE: ./src/modules/Contacts/index.tsx

// EXTERNAL MODULE: ./src/components/Helper/index.ts + 1 modules
var Helper = __webpack_require__(55864);
// EXTERNAL MODULE: ./src/assets/svg/arrow_question.svg
var arrow_question = __webpack_require__(46293);
;// CONCATENATED MODULE: ./src/modules/FAQ/components/Collapse/Collapse.tsx







function Collapse({
  data
}) {
  var _data$answer;

  const {
    0: isOpen,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    0: height,
    1: setHeight
  } = (0,react.useState)(0);
  const ref = (0,react.useRef)(null);

  const opener = () => {
    setOpen(prev => !prev);
  };

  (0,react.useEffect)(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(QuestionCell, {
      active: isOpen,
      onClick: opener,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
        children: data.question
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse_StyledIcon, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Answer, {
        ref: ref,
        active: isOpen,
        size: height,
        dangerouslySetInnerHTML: {
          __html: (_data$answer = data === null || data === void 0 ? void 0 : data.answer) !== null && _data$answer !== void 0 ? _data$answer : ''
        }
      })
    })]
  });
}

/* harmony default export */ var Collapse_Collapse = (Collapse);
const Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__Item",
  componentId: "sc-kz9jm5-0"
})(["padding:10px 15px;"]);
const Question = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Collapse__Question",
  componentId: "sc-kz9jm5-1"
})(["width:75%;font-style:normal;font-weight:500;font-size:12px;line-height:20px;"]);
const QuestionCell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__QuestionCell",
  componentId: "sc-kz9jm5-2"
})(["cursor:pointer;display:flex;align-items:center;justify-content:space-between;& > svg{transition:transform 0.2s ease;}", ""], ({
  active
}) => active && (0,styled_components_browser_esm.css)(["& > span{color:", ";}& > svg{transform:rotate(-180deg);}& > svg path{fill:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary));
const CollapseWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__CollapseWrapper",
  componentId: "sc-kz9jm5-3"
})(["overflow:hidden;"]);
const Answer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__Answer",
  componentId: "sc-kz9jm5-4"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:22px;transition:height 0.2s ease,margin 0.2s ease;", ""], ({
  active,
  size
}) => active ? (0,styled_components_browser_esm.css)(["height:", "px;margin-top:9px;"], size) : (0,styled_components_browser_esm.css)(["height:0;margin-top:0;"]));
const Collapse_StyledIcon = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "Collapse__StyledIcon",
  componentId: "sc-kz9jm5-5"
})([""]);
;// CONCATENATED MODULE: ./src/modules/FAQ/components/Collapse/index.ts

;// CONCATENATED MODULE: ./src/modules/FAQ/FAQ.tsx











function Faq() {
  var _templateField$sectio;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const templateField = page === null || page === void 0 ? void 0 : page.templateFields;
  const breadCrumb = [];

  if (page) {
    breadCrumb.push({
      label: page.title,
      url: page.path
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FAQ_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FAQ_Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
          breadCrumbs: breadCrumb
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle, {
          children: page.title
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FAQ_Content, {
      children: [((_templateField$sectio = templateField === null || templateField === void 0 ? void 0 : templateField.sections) !== null && _templateField$sectio !== void 0 ? _templateField$sectio : []).map((section, index) => {
        var _section$questions;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuestionSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FAQ_Title, {
            children: section.title
          }), ((_section$questions = section === null || section === void 0 ? void 0 : section.questions) !== null && _section$questions !== void 0 ? _section$questions : []).map((question, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse_Collapse, {
            data: question
          }, index))]
        }, index);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Helper/* default */.Z, {})]
    })]
  });
}

/* harmony default export */ var FAQ = (Faq);
const FAQ_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FAQ__Component",
  componentId: "sc-1eejjmy-0"
})([""]);
const FAQ_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FAQ__Header",
  componentId: "sc-1eejjmy-1"
})([""]);
const PageTitle = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "FAQ__PageTitle",
  componentId: "sc-1eejjmy-2"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const FAQ_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FAQ__Content",
  componentId: "sc-1eejjmy-3"
})(["& > div:not(:first-child){margin-top:27px;}"]);
const QuestionSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FAQ__QuestionSection",
  componentId: "sc-1eejjmy-4"
})(["& > div{border-top:1px solid ", ";}& > div:last-child{border-bottom:1px solid ", ";}"], theme/* colors.gray200 */.O9.gray200, theme/* colors.gray200 */.O9.gray200);
const FAQ_Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "FAQ__Title",
  componentId: "sc-1eejjmy-5"
})(["font-style:normal;font-weight:500;font-size:16px;line-height:24px;margin:10px 0 14px;padding:0 15px;"]);
;// CONCATENATED MODULE: ./src/modules/FAQ/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/components/PaymentMethodsSection/components/MethodCard/MethodCard.tsx


function MethodCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MethodCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MethodCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MethodCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function convertUrl(url) {
  return url.replace('http://', '').replace('https://', '').replace('www.', '');
}

function MethodCard({
  data
}) {
  var _data$bankUrl;

  const url = convertUrl((_data$bankUrl = data === null || data === void 0 ? void 0 : data.bankUrl) !== null && _data$bankUrl !== void 0 ? _data$bankUrl : '');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MethodCard_Component, {
    children: [(data === null || data === void 0 ? void 0 : data.disabledText) && /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CautionText, {
        children: [data === null || data === void 0 ? void 0 : data.disabledText, " "]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MethodCard_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PictureWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MethodCard_StyledPicture, MethodCard_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(data.image)))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InnerWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
          children: data === null || data === void 0 ? void 0 : data.name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Bank, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BankTitle, {
            children: (data === null || data === void 0 ? void 0 : data.bankName) + ', '
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            to: data.bankUrl,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankUrl, {
              children: url
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Period, {
          children: data === null || data === void 0 ? void 0 : data.period
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Note, {
      highlight: data.noteHighlight,
      children: data === null || data === void 0 ? void 0 : data.note
    })]
  });
}

/* harmony default export */ var MethodCard_MethodCard = (MethodCard);
const MethodCard_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Component",
  componentId: "sc-apa4w8-0"
})(["position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:space-between;margin-top:12px;min-height:340px;border:1px solid ", ";& > div{text-align:center;}@media (max-width:", "px){& > div{text-align:left;}}"], theme/* colors.gray70 */.O9.gray70, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Overlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Overlay",
  componentId: "sc-apa4w8-1"
})(["position:absolute;inset:0;background-color:rgba(245,245,245,0.5);z-index:1;display:flex;align-items:center;justify-content:center;"]);
const CautionText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__CautionText",
  componentId: "sc-apa4w8-2"
})(["padding:15px 20px;background-color:", ";align-self:center;font-style:normal;font-weight:500;font-size:18px;line-height:22px;"], theme/* colors.gray200 */.O9.gray200);
const MethodCard_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Content",
  componentId: "sc-apa4w8-3"
})(["padding:15px 15px 0;"]);
const MethodCard_StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "MethodCard__StyledPicture",
  componentId: "sc-apa4w8-4"
})(["position:absolute;inset:0;img,picture{width:100%;height:100%;}"]);
const InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__InnerWrapper",
  componentId: "sc-apa4w8-5"
})([""]);
const PictureWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__PictureWrapper",
  componentId: "sc-apa4w8-6"
})(["border-radius:5px;overflow:hidden;position:relative;max-width:280px;margin:0 auto;padding-top:min(60%,130px);"]);
const Name = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "MethodCard__Name",
  componentId: "sc-apa4w8-7"
})(["margin-top:17px;font-style:normal;font-weight:500;font-size:18px;line-height:22px;"]);
const Bank = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Bank",
  componentId: "sc-apa4w8-8"
})(["font-weight:normal;font-size:12px;line-height:22px;"]);
const BankTitle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "MethodCard__BankTitle",
  componentId: "sc-apa4w8-9"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:22px;"]);
const BankUrl = styled_components_browser_esm["default"].span.withConfig({
  displayName: "MethodCard__BankUrl",
  componentId: "sc-apa4w8-10"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:22px;color:", ";"], theme/* colors.primary */.O9.primary);
const Period = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Period",
  componentId: "sc-apa4w8-11"
})(["margin-top:10px;font-style:normal;font-weight:500;font-size:14px;line-height:22px;"]);
const Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MethodCard__Note",
  componentId: "sc-apa4w8-12"
})(["margin-top:10px;width:100%;padding:5px 15px;font-style:normal;font-weight:normal;font-size:12px;line-height:18px;color:", ";background-color:", ";"], ({
  highlight
}) => highlight ? `${theme/* colors.primary */.O9.primary}` : `${theme/* colors.gray900 */.O9.gray900}`, theme/* colors.gray800 */.O9.gray800);
;// CONCATENATED MODULE: ./src/modules/Payment/components/PaymentMethodsSection/components/MethodCard/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/components/PaymentMethodsSection/PaymentMethodsSection.tsx













core_class/* default.use */.Z.use([navigation/* default */.Z]);

function PaymentMethodsSection() {
  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    templateFields
  } = page;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentMethodsSection_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentMethodsSection_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_Title, {
        children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.cardsTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentMethodsSection_Nav, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_Prev, {
          className: "payment-methods-prev"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_Next, {
          className: "payment-methods-next"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
      children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.cardsText
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_Content, {
      children: (templateFields === null || templateFields === void 0 ? void 0 : templateFields.cardsItems) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
        navigation: {
          prevEl: '.payment-methods-prev',
          nextEl: '.payment-methods-next'
        },
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        spaceBetween: 15,
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        breakpoints: {
          500: {
            slidesPerView: 2.2
          }
        },
        children: templateFields.cardsItems.map((card, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MethodCard_MethodCard, {
            data: card
          })
        }, index))
      })
    })]
  });
}

/* harmony default export */ var PaymentMethodsSection_PaymentMethodsSection = (PaymentMethodsSection);
const PaymentMethodsSection_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Component",
  componentId: "sc-8y0tae-0"
})(["margin-top:20px;"]);
const PaymentMethodsSection_Title = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "PaymentMethodsSection__Title",
  componentId: "sc-8y0tae-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:22px;"]);
const PaymentMethodsSection_Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Prev",
  componentId: "sc-8y0tae-2"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const PaymentMethodsSection_Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Next",
  componentId: "sc-8y0tae-3"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const PaymentMethodsSection_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Header",
  componentId: "sc-8y0tae-4"
})(["padding:0 15px;display:flex;align-items:center;justify-content:space-between;"]);
const PaymentMethodsSection_Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Nav",
  componentId: "sc-8y0tae-5"
})(["margin-left:50px;display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Text",
  componentId: "sc-8y0tae-6"
})(["padding:0 15px;margin-top:5px;font-style:normal;font-weight:500;font-size:13px;line-height:22px;"]);
const PaymentMethodsSection_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentMethodsSection__Content",
  componentId: "sc-8y0tae-7"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Payment/components/PaymentMethodsSection/index.ts

// EXTERNAL MODULE: ./src/utils/mixin.ts
var mixin = __webpack_require__(26542);
;// CONCATENATED MODULE: ./src/modules/Payment/components/RassrochkaSection/RassrochkaSection.tsx










function RassrochkaSection({
  title,
  note,
  content
}) {
  const creditPrices = (0,hooks/* useSettingItem */.qT)('PRICES_CREDIT');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Components, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RassrochkaSection_Title, {
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RassrochkaSection_Note, {
        children: note
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RassrochkaSection_Content, {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
          children: t('rassrochka.heading_1')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
          children: t('rassrochka.heading_2')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
          children: t('rassrochka.heading_3')
        }), (creditPrices !== null && creditPrices !== void 0 ? creditPrices : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RassrochkaSection_Item, {
            children: [item.initial, "%"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RassrochkaSection_Item, {
            children: [item.period, " ", t('dimensions.months')]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RassrochkaSection_Item, {
            children: [item.underPayment, "%"]
          })]
        }, index))]
      })]
    })
  });
}

/* harmony default export */ var RassrochkaSection_RassrochkaSection = (RassrochkaSection);
const Components = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Components",
  componentId: "sc-lms0gi-0"
})(["margin-top:35px;"]);
const RassrochkaSection_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Title",
  componentId: "sc-lms0gi-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:22px;"]);
const RassrochkaSection_Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Note",
  componentId: "sc-lms0gi-2"
})(["margin-top:5px;font-style:normal;font-weight:normal;font-size:12px;line-height:20px;"]);
const RassrochkaSection_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Content",
  componentId: "sc-lms0gi-3"
})(["margin-top:17px;& > p:not(:first-child){margin-top:20px;}"]);
const Table = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Table",
  componentId: "sc-lms0gi-4"
})(["padding:13px 20px 21px 15px;margin-top:26px;display:flex;flex-wrap:wrap;overflow:hidden;border:2px solid ", ";"], theme/* colors.primary */.O9.primary);
const Heading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Heading",
  componentId: "sc-lms0gi-5"
})(["padding:2px 4px;text-align:center;width:33.33%;overflow-wrap:break-word;font-style:normal;font-weight:600;font-size:14px;line-height:24px;color:", ";", ""], theme/* colors.primary */.O9.primary, mixin/* media.mobileMedium */.B.mobileMedium((0,styled_components_browser_esm.css)(["font-size:11px;"])));
const RassrochkaSection_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Item",
  componentId: "sc-lms0gi-6"
})(["flex:1 0 33.33%;text-align:center;font-style:normal;font-weight:normal;font-size:18px;line-height:30px;", ";"], mixin/* media.mobileMedium */.B.mobileMedium((0,styled_components_browser_esm.css)(["font-size:14px;"])));
const Row = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RassrochkaSection__Row",
  componentId: "sc-lms0gi-7"
})(["margin-top:5px;display:flex;width:100%;"]);
;// CONCATENATED MODULE: ./src/modules/Payment/components/RassrochkaSection/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/components/Erip/Erip.tsx







function Erip() {
  var _templateFields$eripC;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    templateFields
  } = page;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Erip_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Erip_Title, {
        children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.eripTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Erip_Note, {
        children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.eripNote
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Erip_Content, {
        dangerouslySetInnerHTML: {
          __html: (_templateFields$eripC = templateFields === null || templateFields === void 0 ? void 0 : templateFields.eripContent) !== null && _templateFields$eripC !== void 0 ? _templateFields$eripC : ''
        }
      })]
    })
  });
}

/* harmony default export */ var Erip_Erip = (Erip);
const Erip_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Erip__Component",
  componentId: "sc-8nqj6i-0"
})(["margin-top:35px;"]);
const Erip_Title = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "Erip__Title",
  componentId: "sc-8nqj6i-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:22px;"]);
const Erip_Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Erip__Note",
  componentId: "sc-8nqj6i-2"
})(["margin-top:6px;"]);
const Erip_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Erip__Content",
  componentId: "sc-8nqj6i-3"
})(["margin-top:18px;& > p,ul{margin-top:18px;}& > ul li{margin-left:15px;list-style:initial;}& > ul li:not(:first-child){margin-top:20px;}"]);
;// CONCATENATED MODULE: ./src/modules/Payment/components/Erip/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/components/DocumentCard/DocumentCard.tsx


function DocumentCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DocumentCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DocumentCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DocumentCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function DocumentCard({
  data,
  onClick
}) {
  var _data$file;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard_Component, {
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DocumentCard_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard_StyledPicture, DocumentCard_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)((_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.cover)))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Caption, {
        children: data.caption
      })]
    })
  });
}

/* harmony default export */ var DocumentCard_DocumentCard = (DocumentCard);
const DocumentCard_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentCard__Component",
  componentId: "sc-mbsnli-0"
})(["cursor:pointer;margin-top:12px;min-height:250px;"]);
const DocumentCard_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentCard__Content",
  componentId: "sc-mbsnli-1"
})(["padding:5px 5px 10px;border:1px solid ", ";"], theme/* colors.gray70 */.O9.gray70);
const Caption = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentCard__Caption",
  componentId: "sc-mbsnli-2"
})(["margin-top:5px;font-style:normal;font-weight:500;font-size:14px;line-height:24px;text-align:center;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;"]);
const DocumentCard_StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "DocumentCard__StyledPicture",
  componentId: "sc-mbsnli-3"
})(["position:absolute;inset:0;img,picture{width:100%;height:100%;}"]);
const Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentCard__Wrapper",
  componentId: "sc-mbsnli-4"
})(["position:relative;max-width:300px;margin:0 auto;padding-top:min(83%,210px);"]);
;// CONCATENATED MODULE: ./src/modules/Payment/components/DocumentCard/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/components/DocumentSection/DocumentSection.tsx














core_class/* default.use */.Z.use([navigation/* default */.Z]);

function DocumentSection() {
  var _templateFields$docum;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    templateFields
  } = page;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DocumentsContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DocumentSection_Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DocumentSection_Title, {
          children: templateFields === null || templateFields === void 0 ? void 0 : templateFields.documentsTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DocumentSection_Nav, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DocumentSection_Prev, {
            className: "document-card-prev"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentSection_Next, {
            className: "document-card-next"
          })]
        })]
      })
    }), (templateFields === null || templateFields === void 0 ? void 0 : templateFields.documentsItems) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
      navigation: {
        prevEl: '.document-card-prev',
        nextEl: '.document-card-next'
      },
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      spaceBetween: 15,
      slidesPerView: 1.25,
      slidesPerGroup: 1,
      breakpoints: {
        500: {
          slidesPerView: 2.2
        }
      },
      children: templateFields.documentsItems.map((doc, index) => {
        var _doc$caption;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard_DocumentCard, {
            data: doc
          })
        }, (_doc$caption = doc === null || doc === void 0 ? void 0 : doc.caption) !== null && _doc$caption !== void 0 ? _doc$caption : '' + index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentText, {
      dangerouslySetInnerHTML: {
        __html: (_templateFields$docum = templateFields === null || templateFields === void 0 ? void 0 : templateFields.documentsText) !== null && _templateFields$docum !== void 0 ? _templateFields$docum : ''
      }
    })]
  });
}

/* harmony default export */ var DocumentSection_DocumentSection = (DocumentSection);
const DocumentsContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__DocumentsContainer",
  componentId: "sc-1ngd65-0"
})(["margin-top:30px;padding-bottom:17px;border-bottom:1px solid ", ";"], theme/* colors.gray70 */.O9.gray70);
const DocumentSection_Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "DocumentSection__Title",
  componentId: "sc-1ngd65-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const DocumentSection_Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__Nav",
  componentId: "sc-1ngd65-2"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const DocumentSection_Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__Prev",
  componentId: "sc-1ngd65-3"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const DocumentSection_Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__Next",
  componentId: "sc-1ngd65-4"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const DocumentSection_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__Header",
  componentId: "sc-1ngd65-5"
})(["display:flex;align-items:center;justify-content:space-between;"]);
const DocumentText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DocumentSection__DocumentText",
  componentId: "sc-1ngd65-6"
})(["margin-top:15px;padding:0 15px;& > p:not(:first-child){margin-top:20px;}"]);
;// CONCATENATED MODULE: ./src/modules/Payment/components/DocumentSection/index.ts

// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
;// CONCATENATED MODULE: ./src/modules/Payment/components/Item/Item.tsx


function Item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Item_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Item_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function Item_Item({
  item
}) {
  const {
    button,
    title,
    image,
    description
  } = item;

  const clickHandler = () => {
    if ((0,web_core_esm.isBrowser)()) {
      var _button$link;

      const domNode = document.querySelector((_button$link = button === null || button === void 0 ? void 0 : button.link) !== null && _button$link !== void 0 ? _button$link : '');
      const yOffset = -80;

      if (domNode) {
        window.scroll({
          top: domNode.getBoundingClientRect().top + window.pageYOffset + yOffset,
          behavior: 'smooth'
        });
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Item_StyledPicture, Item_objectSpread(Item_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureImage */.iS)(image)), {}, {
      alt: title !== null && title !== void 0 ? title : ''
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item_Description, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Item_Title, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Item_Text, {
        children: description
      }), item.button && /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
        onClick: clickHandler,
        children: button === null || button === void 0 ? void 0 : button.label
      })]
    })]
  });
}

/* harmony default export */ var components_Item_Item = (Item_Item);
const Item_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Item__Component",
  componentId: "sc-17n4fg1-0"
})(["padding:20px 15px;display:flex;align-items:flex-start;"]);
const Item_StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "Item__StyledPicture",
  componentId: "sc-17n4fg1-1"
})(["min-width:70px;"]);
const Item_Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Item__Description",
  componentId: "sc-17n4fg1-2"
})(["margin-left:16px;"]);
const Item_Title = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "Item__Title",
  componentId: "sc-17n4fg1-3"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:22px;"]);
const Item_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Item__Text",
  componentId: "sc-17n4fg1-4"
})(["margin-top:5px;font-style:normal;font-weight:normal;font-size:12px;line-height:18px;"]);
const Button = styled_components_browser_esm["default"].button.withConfig({
  displayName: "Item__Button",
  componentId: "sc-17n4fg1-5"
})(["margin-top:17px;padding:3px 10px;cursor:pointer;border-radius:0;font-style:normal;font-size:13px;line-height:20px;display:inline-block;width:100px;background-color:", ";color:#fff;"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/modules/Payment/components/Item/index.ts

;// CONCATENATED MODULE: ./src/modules/Payment/Payment.tsx


















function Payment() {
  var _page$body, _templateFields$items, _templateFields$rassr, _templateFields$rassr2, _templateFields$rassr3;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const templateFields = page === null || page === void 0 ? void 0 : page.templateFields;
  const breadCrumb = [];

  if (page) {
    breadCrumb.push({
      label: page.title,
      url: page.path
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Payment_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Header, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
          breadCrumbs: breadCrumb
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Methods, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Title, {
          children: page.seoParams.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Text, {
          dangerouslySetInnerHTML: {
            __html: (_page$body = page.body) !== null && _page$body !== void 0 ? _page$body : ''
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemContainer, {
        children: ((_templateFields$items = templateFields === null || templateFields === void 0 ? void 0 : templateFields.items) !== null && _templateFields$items !== void 0 ? _templateFields$items : []).map((item, index) => {
          var _item$title;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Item_Item, {
            item: item
          }, (_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : '' + index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentSection_DocumentSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Wrapper, {
        id: "cards",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_PaymentMethodsSection, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Wrapper, {
        id: "rassrochka",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RassrochkaSection_RassrochkaSection, {
          title: (_templateFields$rassr = templateFields === null || templateFields === void 0 ? void 0 : templateFields.rassrochkaTitle) !== null && _templateFields$rassr !== void 0 ? _templateFields$rassr : '',
          note: (_templateFields$rassr2 = templateFields === null || templateFields === void 0 ? void 0 : templateFields.rassrochkaNote) !== null && _templateFields$rassr2 !== void 0 ? _templateFields$rassr2 : '',
          content: (_templateFields$rassr3 = templateFields === null || templateFields === void 0 ? void 0 : templateFields.rassrochkaContent) !== null && _templateFields$rassr3 !== void 0 ? _templateFields$rassr3 : ''
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_Wrapper, {
        id: "erip",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Erip_Erip, {})
      })]
    })]
  });
}

/* harmony default export */ var Payment_Payment = (Payment);
const Payment_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__Component",
  componentId: "sc-1twimb1-0"
})([""]);
const Payment_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__Header",
  componentId: "sc-1twimb1-1"
})([""]);
const Payment_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__Wrapper",
  componentId: "sc-1twimb1-2"
})([""]);
const Methods = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__Methods",
  componentId: "sc-1twimb1-3"
})([""]);
const Payment_Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Payment__Title",
  componentId: "sc-1twimb1-4"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const Payment_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__Text",
  componentId: "sc-1twimb1-5"
})(["margin-top:10px;"]);
const ItemContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Payment__ItemContainer",
  componentId: "sc-1twimb1-6"
})(["margin-top:25px;& > div{border-bottom:1px solid ", ";}& > div:first-child{border-top:1px solid ", ";}"], theme/* colors.grayDivider */.O9.grayDivider, theme/* colors.grayDivider */.O9.grayDivider);
;// CONCATENATED MODULE: ./src/modules/Payment/index.ts

// EXTERNAL MODULE: ./src/components/Button/index.ts
var components_Button = __webpack_require__(91533);
;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Description/Description.tsx









function Description_Description({
  title,
  body,
  data
}) {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Description_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description_Header, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description_Title, {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Body, {
          dangerouslySetInnerHTML: {
            __html: body !== null && body !== void 0 ? body : ''
          }
        })]
      })
    }), data && data.map(({
      title,
      prices,
      text,
      button
    }, index) => {
      var _button$link;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description_Title, {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceSection, {
            children: !!(prices !== null && prices !== void 0 && prices.length) && prices.map(({
              name,
              price
            }, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description_Name, {
                children: name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Price, {
                isChargeFree: price === t('free'),
                children: price
              })]
            }, index))
          }), text && /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Text, {
            dangerouslySetInnerHTML: {
              __html: text
            }
          }), button && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonLink, {
            variant: 'outlined-primary-w100-f13',
            href: (_button$link = button.link) !== null && _button$link !== void 0 ? _button$link : '',
            target: button.isNewTab ? '_blank' : '_self',
            children: button.label
          })]
        })
      }, index);
    })]
  });
}

/* harmony default export */ var components_Description_Description = (Description_Description);
const Description_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Component",
  componentId: "sc-ou4wrc-0"
})(["margin-top:8px;"]);
const Description_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Header",
  componentId: "sc-ou4wrc-1"
})(["border-bottom:1px solid ", ";padding-bottom:10px;"], theme/* colors.gray70 */.O9.gray70);
const Section = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Section",
  componentId: "sc-ou4wrc-2"
})(["padding:15px 0 18px;border-bottom:1px solid ", ";"], theme/* colors.gray70 */.O9.gray70);
const PriceSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__PriceSection",
  componentId: "sc-ou4wrc-3"
})(["& > div{margin-top:15px;}& > div:first-child{margin-top:5px;}"]);
const PriceInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__PriceInner",
  componentId: "sc-ou4wrc-4"
})([""]);
const Description_Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Description__Title",
  componentId: "sc-ou4wrc-5"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const Description_Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Body",
  componentId: "sc-ou4wrc-6"
})(["margin-top:6px;font-style:normal;font-weight:normal;font-size:13px;line-height:22px;"]);
const Description_Name = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Name",
  componentId: "sc-ou4wrc-7"
})(["font-style:normal;font-weight:500;font-size:14px;line-height:24px;"]);
const Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Price",
  componentId: "sc-ou4wrc-8"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;color:", ";"], ({
  isChargeFree
}) => isChargeFree ? `${theme/* colors.primary */.O9.primary}` : `${theme/* colors.black */.O9.black}`);
const Description_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Text",
  componentId: "sc-ou4wrc-9"
})(["margin-top:10px;font-style:normal;font-weight:normal;font-size:13px;line-height:24px;& > p{margin-top:5px;}"]);
const StyledButtonLink = (0,styled_components_browser_esm["default"])(components_Button/* ButtonLink */.Z).withConfig({
  displayName: "Description__StyledButtonLink",
  componentId: "sc-ou4wrc-10"
})(["margin-top:25px;max-width:480px;"]);
;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Description/index.ts

;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Map/Map.tsx





function Map_Map({
  title,
  data
}) {
  if (!data) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Map_Component, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Map_Title, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Map_Content, {})]
    });
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Map_Component, {
      children: data
    });
  }
}

/* harmony default export */ var components_Map_Map = (Map_Map);
const Map_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Map__Component",
  componentId: "sc-1dkzxhn-0"
})(["margin-top:25px;"]);
const Map_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Map__Title",
  componentId: "sc-1dkzxhn-1"
})(["font-style:normal;font-weight:500;font-size:20px;line-height:22px;"]);
const Map_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Map__Content",
  componentId: "sc-1dkzxhn-2"
})(["margin-top:13px;display:flex;align-items:center;justify-content:center;height:250px;font-style:normal;font-weight:500;font-size:24px;line-height:22px;background-color:rgba(224,224,224,0.5);"]);
;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Map/index.ts

;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Terms/Terms.tsx






function Terms({
  title,
  content
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Terms_Title, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_Content, {
        dangerouslySetInnerHTML: {
          __html: content !== null && content !== void 0 ? content : ''
        }
      })]
    })
  });
}

/* harmony default export */ var Terms_Terms = (Terms);
const Terms_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Terms__Component",
  componentId: "sc-19t3fdg-0"
})(["margin-top:20px;"]);
const Terms_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Terms__Title",
  componentId: "sc-19t3fdg-1"
})(["font-style:normal;font-weight:500;font-size:20px;line-height:22px;"]);
const Terms_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Terms__Content",
  componentId: "sc-19t3fdg-2"
})(["margin-top:15px;ul > li{list-style:initial;margin-left:15px;margin-top:30px;}ul > li:first-child{margin-top:0;}"]);
;// CONCATENATED MODULE: ./src/modules/Dostavka/components/Terms/index.ts

;// CONCATENATED MODULE: ./src/modules/Dostavka/Dostavka.tsx











function Dostavka() {
  var _page$body, _templateFields$items, _templateFields$mapTi, _templateFields$textT, _templateFields$textC;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const {
    templateFields
  } = page;
  const breadCrumbs = [];

  if (page) {
    breadCrumbs.push({
      label: page.title,
      url: page.path
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dostavka_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
        breadCrumbs: breadCrumbs
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Description_Description, {
      title: page.title,
      body: (_page$body = page === null || page === void 0 ? void 0 : page.body) !== null && _page$body !== void 0 ? _page$body : '',
      data: (_templateFields$items = templateFields === null || templateFields === void 0 ? void 0 : templateFields.items) !== null && _templateFields$items !== void 0 ? _templateFields$items : []
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Map_Map, {
      title: (_templateFields$mapTi = templateFields === null || templateFields === void 0 ? void 0 : templateFields.mapTitle) !== null && _templateFields$mapTi !== void 0 ? _templateFields$mapTi : ''
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_Terms, {
      title: (_templateFields$textT = templateFields === null || templateFields === void 0 ? void 0 : templateFields.textTitle) !== null && _templateFields$textT !== void 0 ? _templateFields$textT : '',
      content: (_templateFields$textC = templateFields === null || templateFields === void 0 ? void 0 : templateFields.textContent) !== null && _templateFields$textC !== void 0 ? _templateFields$textC : ''
    })]
  });
}

/* harmony default export */ var Dostavka_Dostavka = (Dostavka);
const Dostavka_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Dostavka__Component",
  componentId: "sc-he6ufo-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Dostavka/index.ts

// EXTERNAL MODULE: ./src/modules/Rassrochka/components/Calculator/Clculator.typings.ts
var Clculator_typings = __webpack_require__(44260);
// EXTERNAL MODULE: ./src/modules/Rassrochka/components/Calculator/Calculator.helpers.ts
var Calculator_helpers = __webpack_require__(31346);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/assets/svg/cart.svg
var cart = __webpack_require__(53784);
// EXTERNAL MODULE: ./src/assets/svg/wallet_small.svg
var wallet_small = __webpack_require__(47829);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/components/Calculator/components/CalculatorInput.tsx


const _excluded = ["icon"];

function CalculatorInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CalculatorInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CalculatorInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CalculatorInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function CalculatorInput(_ref, ref) {
  let {
    icon
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const CurrentIcon = icon === 'cart' ? cart/* ReactComponent */.r : wallet_small/* ReactComponent */.r;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorInput_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconItem, {
      as: CurrentIcon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, CalculatorInput_objectSpread({
      ref: ref
    }, rest))]
  });
}

/* harmony default export */ var components_CalculatorInput = (/*#__PURE__*/react.forwardRef(CalculatorInput));
const CalculatorInput_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorInput__Container",
  componentId: "sc-w8sdaw-0"
})(["position:relative;width:100%;height:35px;"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "CalculatorInput__Input",
  componentId: "sc-w8sdaw-1"
})(["padding-left:40px;width:100%;height:100%;border:1px solid ", ";border-radius:5px;font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"], theme/* colors.gray70 */.O9.gray70);
const IconItem = styled_components_browser_esm["default"].svg.withConfig({
  displayName: "CalculatorInput__IconItem",
  componentId: "sc-w8sdaw-2"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);"]);
// EXTERNAL MODULE: ./src/assets/svg/time.svg
var time = __webpack_require__(21574);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/components/Calculator/components/CalculatorSelect.tsx









function CalculatorSelect({
  data,
  setData
}) {
  var _data$currentPeriodIn, _data$currentPeriodIn2;

  const {
    0: currentPeriodIndex,
    1: setIndex
  } = (0,react.useState)(0);
  const {
    0: isOptionsOpen,
    1: setOpen
  } = (0,react.useState)(false);

  const selectHandler = () => {
    setOpen(pre => !pre);
  };

  const clickHandler = index => {
    setIndex(index);
    setData(index);
  };

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Component, {
    onClick: selectHandler,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTime, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Option, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Label, {
        isSelected: true,
        children: [(_data$currentPeriodIn = (_data$currentPeriodIn2 = data[currentPeriodIndex]) === null || _data$currentPeriodIn2 === void 0 ? void 0 : _data$currentPeriodIn2.period) !== null && _data$currentPeriodIn !== void 0 ? _data$currentPeriodIn : '', " ", t('dimensions.months')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyleArrow, {
        isOpen: isOptionsOpen
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CalculatorSelect_Collapse, {
      isVisible: isOptionsOpen,
      children: !!data.length && data.map(({
        period
      }, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
        onClick: () => clickHandler(index),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Label, {
          children: [period !== null && period !== void 0 ? period : '', " ", t('dimensions.months')]
        })
      }, index))
    })]
  });
}

/* harmony default export */ var components_CalculatorSelect = (CalculatorSelect);
const CalculatorSelect_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Component",
  componentId: "sc-k3hmez-0"
})(["position:relative;display:flex;align-items:center;flex-direction:column;padding:4px 15px 4px 40px;min-height:34px;cursor:pointer;border:1px solid ", ";border-radius:5px;"], theme/* colors.gray70 */.O9.gray70);
const StyledTime = (0,styled_components_browser_esm["default"])(time/* ReactComponent */.r).withConfig({
  displayName: "CalculatorSelect__StyledTime",
  componentId: "sc-k3hmez-1"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);"]);
const Option = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Option",
  componentId: "sc-k3hmez-2"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;flex:1;"]);
const CalculatorSelect_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Label",
  componentId: "sc-k3hmez-3"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;color:", ";&:hover{color:", ";}"], ({
  isSelected
}) => isSelected ? `${theme/* colors.primary */.O9.primary}` : `${theme/* colors.black */.O9.black}`, theme/* colors.primary */.O9.primary);
const StyleArrow = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "CalculatorSelect__StyleArrow",
  componentId: "sc-k3hmez-4"
})(["transform:", ";path{fill:rgba(0,0,0,1);}"], ({
  isOpen
}) => isOpen ? 'rotate(180deg)' : 'rotate(0)');
const CalculatorSelect_Collapse = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Collapse",
  componentId: "sc-k3hmez-5"
})(["position:absolute;display:", ";width:100%;padding:4px 0 4px 15px;top:calc(100% + 1px);left:0;background-color:white;z-index:3;border:1px solid ", ";border-radius:5px;"], ({
  isVisible
}) => isVisible ? 'block' : 'none', theme/* colors.gray70 */.O9.gray70);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/wallet.svg
var wallet = __webpack_require__(65497);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/bank.svg
var bank = __webpack_require__(53497);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/card.svg
var card = __webpack_require__(80305);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/components/Calculator/components/Output.tsx












function Output({
  output
}) {
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(wallet/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.summary'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          children: [(0,common/* normalizePrice */.nQ)(output.price), " ", currency]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bank/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.overpay'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          children: [(0,common/* normalizePrice */.nQ)(output.underpayment), " ", currency]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(card/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.month_payment'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          monthly: true,
          children: [(0,common/* normalizePrice */.nQ)(output.monthlyPayment), " ", currency]
        })]
      })]
    })]
  });
}

/* harmony default export */ var components_Output = (Output);
const Output_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Component",
  componentId: "sc-1kc2gs1-0"
})(["max-width:480px;padding:10px 15px;margin-top:20px;background-color:", ";border-radius:5px;"], theme/* colors.primary */.O9.primary);
const Output_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Item",
  componentId: "sc-1kc2gs1-1"
})(["display:flex;align-items:center;"]);
const Output_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Label",
  componentId: "sc-1kc2gs1-2"
})(["font-style:normal;font-weight:600;font-size:14px;line-height:30px;color:", ";"], theme/* colors.white */.O9.white);
const Output_Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Note",
  componentId: "sc-1kc2gs1-3"
})(["font-style:normal;font-weight:", ";font-size:20px;line-height:30px;color:", ";"], ({
  monthly
}) => monthly ? '600' : 'normal', theme/* colors.white */.O9.white);
const Output_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Content",
  componentId: "sc-1kc2gs1-4"
})(["margin-left:11px;"]);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/components/Calculator/Calculator.tsx


function Calculator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Calculator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Calculator_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Calculator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














const initOutputState = {
  price: 0,
  underpayment: 0,
  monthlyPayment: 0
};
const initialState = {
  periodSelected: 0,
  price: 1000,
  initPaymentRate: 25,
  rate: 0,
  initialPayment: (0,Calculator_helpers/* getQuarterToString */.N)(1000, 25)
};

const calcReducer = (state, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD:
      return Calculator_objectSpread(Calculator_objectSpread({}, state), {}, {
        periodSelected: payload
      });

    case Clculator_typings/* ActionType.SETPRICE */.U.SETPRICE:
      return Calculator_objectSpread(Calculator_objectSpread({}, state), {}, {
        price: payload
      });

    case Clculator_typings/* ActionType.SETINITPAYMENTRATE */.U.SETINITPAYMENTRATE:
      return Calculator_objectSpread(Calculator_objectSpread({}, state), {}, {
        initPaymentRate: payload
      });

    case Clculator_typings/* ActionType.SETRATE */.U.SETRATE:
      return Calculator_objectSpread(Calculator_objectSpread({}, state), {}, {
        rate: payload
      });

    case Clculator_typings/* ActionType.SETINITIALPAYMENT */.U.SETINITIALPAYMENT:
      return Calculator_objectSpread(Calculator_objectSpread({}, state), {}, {
        initialPayment: payload
      });

    default:
      return state;
  }
};

function Calculator() {
  const {
    0: state,
    1: dispatch
  } = (0,react.useReducer)(calcReducer, initialState);
  const {
    0: outputData,
    1: setOutputData
  } = (0,react.useState)(initOutputState);
  const creditPrices = (0,hooks/* useSettingItem */.qT)('PRICES_CREDIT');
  const setPeriodAndRate = (0,react.useCallback)(periodIndex => {
    const period = creditPrices[periodIndex].period;
    const rate = creditPrices[periodIndex].underPayment;

    if (period && Number(period) !== state.periodSelected) {
      dispatch({
        type: Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD,
        payload: Number(period)
      });
      dispatch({
        type: Clculator_typings/* ActionType.SETRATE */.U.SETRATE,
        payload: Number(rate)
      });
    }
  }, [creditPrices, state.periodSelected]);

  const getItemPrice = e => {
    const value = Number(e.target.value.trim());
    dispatch({
      type: Clculator_typings/* ActionType.SETPRICE */.U.SETPRICE,
      payload: value
    });
  };

  const getFirstCost = e => {
    dispatch({
      type: Clculator_typings/* ActionType.SETINITIALPAYMENT */.U.SETINITIALPAYMENT,
      payload: Number(e.target.value.trim())
    });
  };

  (0,react.useEffect)(() => {
    const {
      period,
      initial,
      underPayment
    } = creditPrices[0];

    if (period) {
      dispatch({
        type: Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD,
        payload: Number(period)
      });
    }

    if (initial) {
      dispatch({
        type: Clculator_typings/* ActionType.SETINITPAYMENTRATE */.U.SETINITPAYMENTRATE,
        payload: Number(initial)
      });
    }

    if (underPayment) {
      dispatch({
        type: Clculator_typings/* ActionType.SETRATE */.U.SETRATE,
        payload: Number(underPayment)
      });
    }
  }, [creditPrices]);
  (0,react.useEffect)(() => {
    const data = (0,Calculator_helpers/* getFinalPrice */.e)(state.price, state.rate, state.initialPayment, state.periodSelected);
    setOutputData(data);
  }, [state.price, state.rate, state.initialPayment, state.periodSelected]);
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Calculator_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Calculator_Title, {
        children: t('rassrochka.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Calculator_Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Calculator_Label, {
          children: [t('rassrochka.price'), ", ", currency]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CalculatorInput, {
          value: state.price,
          icon: "cart",
          onChange: getItemPrice
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Calculator_Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Calculator_Label, {
          children: t('rassrochka.period')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CalculatorSelect, {
          setData: setPeriodAndRate,
          data: creditPrices
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Calculator_Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Calculator_Label, {
          children: [t('rassrochka.initial_payment'), " (", t('dimensions.from'), " 25%)"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CalculatorInput, {
          value: state.initialPayment,
          icon: "wallet",
          onChange: getFirstCost
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Output, {
        output: outputData
      })]
    })
  });
}

/* harmony default export */ var Calculator_Calculator = (Calculator);
const Calculator_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calculator__Component",
  componentId: "sc-8z1tsn-0"
})(["background:", ";padding:17px 0;"], theme/* colors.white */.O9.white);
const Calculator_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calculator__Title",
  componentId: "sc-8z1tsn-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const Calculator_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calculator__Item",
  componentId: "sc-8z1tsn-2"
})(["margin-top:19px;max-width:480px;"]);
const Calculator_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calculator__Label",
  componentId: "sc-8z1tsn-3"
})(["margin-bottom:7px;font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"]);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/components/Calculator/index.ts

;// CONCATENATED MODULE: ./src/modules/Rassrochka/Rassrochka.tsx











function Rassrochka() {
  var _page$body;

  const page = (0,hooks/* useCurrentPage */.Wo)();
  const breadCrumbList = [];

  if (page) {
    breadCrumbList.push({
      label: page.title,
      url: page.path
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Rassrochka_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Top, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
          breadCrumbs: breadCrumbList
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Rassrochka_Title, {
          children: page.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Rassrochka_Body, {
          dangerouslySetInnerHTML: {
            __html: (_page$body = page === null || page === void 0 ? void 0 : page.body) !== null && _page$body !== void 0 ? _page$body : ''
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calculator_Calculator, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(MethodsWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodsSection_PaymentMethodsSection, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Rassrochka_Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RassrochkaSection_RassrochkaSection, {
        title: '',
        note: '',
        content: ''
      })
    })]
  });
}

/* harmony default export */ var Rassrochka_Rassrochka = (Rassrochka);
const Rassrochka_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Rassrochka__Component",
  componentId: "sc-8y6r6x-0"
})([""]);
const Top = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Rassrochka__Top",
  componentId: "sc-8y6r6x-1"
})([""]);
const Rassrochka_Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Rassrochka__Title",
  componentId: "sc-8y6r6x-2"
})(["margin-top:8px;"]);
const Rassrochka_Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Rassrochka__Body",
  componentId: "sc-8y6r6x-3"
})(["margin-top:5px;& > p:not(:first-child){margin-top:30px;}& > ul{margin-top:30px;}& > ul > li:not(:first-child){margin-top:20px;}& > ul > li{margin-left:15px;list-style:initial;}"]);
const Rassrochka_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Rassrochka__Wrapper",
  componentId: "sc-8y6r6x-4"
})(["margin-top:40px;"]);
const MethodsWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Rassrochka__MethodsWrapper",
  componentId: "sc-8y6r6x-5"
})(["margin-top:23px;"]);
;// CONCATENATED MODULE: ./src/modules/Rassrochka/index.ts

;// CONCATENATED MODULE: ./src/modules/DveriContacts/assets/email.svg
function email_extends() { email_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return email_extends.apply(this, arguments); }



var email_ref = /*#__PURE__*/react.createElement("path", {
  d: "M20.4531 4.37793H4.45312C3.92269 4.37793 3.41398 4.60269 3.03891 5.00277C2.66384 5.40285 2.45313 5.94547 2.45312 6.51126V18.2446C2.45313 18.8104 2.66384 19.353 3.03891 19.7531C3.41398 20.1532 3.92269 20.3779 4.45312 20.3779H20.4531C20.9836 20.3779 21.4923 20.1532 21.8673 19.7531C22.2424 19.353 22.4531 18.8104 22.4531 18.2446V6.51126C22.4531 5.94547 22.2424 5.40285 21.8673 5.00277C21.4923 4.60269 20.9836 4.37793 20.4531 4.37793ZM19.9061 6.51126L12.4961 13.2142L5.00913 6.51126H19.9061ZM4.45312 18.2446V8.79926L11.2531 14.8793C11.5953 15.1537 12.012 15.3017 12.4401 15.3006C12.8946 15.2987 13.336 15.1384 13.6971 14.8441L20.4531 8.79926V18.2446H4.45312Z",
  fill: "#C81E1E"
});

function SvgEmail({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", email_extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, email_ref);
}

/* harmony default export */ var email = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjAuNDUzMSA0LjM3NzkzSDQuNDUzMTJDMy45MjI2OSA0LjM3NzkzIDMuNDEzOTggNC42MDI2OSAzLjAzODkxIDUuMDAyNzdDMi42NjM4NCA1LjQwMjg1IDIuNDUzMTMgNS45NDU0NyAyLjQ1MzEyIDYuNTExMjZWMTguMjQ0NkMyLjQ1MzEzIDE4LjgxMDQgMi42NjM4NCAxOS4zNTMgMy4wMzg5MSAxOS43NTMxQzMuNDEzOTggMjAuMTUzMiAzLjkyMjY5IDIwLjM3NzkgNC40NTMxMiAyMC4zNzc5SDIwLjQ1MzFDMjAuOTgzNiAyMC4zNzc5IDIxLjQ5MjMgMjAuMTUzMiAyMS44NjczIDE5Ljc1MzFDMjIuMjQyNCAxOS4zNTMgMjIuNDUzMSAxOC44MTA0IDIyLjQ1MzEgMTguMjQ0NlY2LjUxMTI2QzIyLjQ1MzEgNS45NDU0NyAyMi4yNDI0IDUuNDAyODUgMjEuODY3MyA1LjAwMjc3QzIxLjQ5MjMgNC42MDI2OSAyMC45ODM2IDQuMzc3OTMgMjAuNDUzMSA0LjM3NzkzWk0xOS45MDYxIDYuNTExMjZMMTIuNDk2MSAxMy4yMTQyTDUuMDA5MTMgNi41MTEyNkgxOS45MDYxWk00LjQ1MzEyIDE4LjI0NDZWOC43OTkyNkwxMS4yNTMxIDE0Ljg3OTNDMTEuNTk1MyAxNS4xNTM3IDEyLjAxMiAxNS4zMDE3IDEyLjQ0MDEgMTUuMzAwNkMxMi44OTQ2IDE1LjI5ODcgMTMuMzM2IDE1LjEzODQgMTMuNjk3MSAxNC44NDQxTDIwLjQ1MzEgOC43OTkyNlYxOC4yNDQ2SDQuNDUzMTJaIiBmaWxsPSIjQzgxRTFFIi8+Cjwvc3ZnPgo=");

;// CONCATENATED MODULE: ./src/modules/DveriContacts/assets/phone.svg
function phone_extends() { phone_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }



var phone_ref = /*#__PURE__*/react.createElement("path", {
  d: "M2.45312 3.87793C2.45312 3.61271 2.55848 3.35836 2.74602 3.17082C2.93355 2.98329 3.18791 2.87793 3.45312 2.87793H5.60612C5.84283 2.87804 6.07182 2.96211 6.25237 3.11519C6.43291 3.26827 6.55331 3.48043 6.59212 3.71393L7.33213 8.14893C7.36748 8.36015 7.3341 8.57714 7.23689 8.76796C7.13968 8.95878 6.98377 9.11336 6.79213 9.20893L5.24412 9.98193C5.79923 11.3576 6.62596 12.6072 7.6749 13.6562C8.72384 14.7051 9.97347 15.5318 11.3491 16.0869L12.1231 14.5389C12.2186 14.3475 12.3731 14.1917 12.5637 14.0945C12.7543 13.9973 12.9711 13.9638 13.1821 13.9989L17.6171 14.7389C17.8506 14.7777 18.0628 14.8981 18.2159 15.0787C18.3689 15.2592 18.453 15.4882 18.4531 15.7249V17.8779C18.4531 18.1431 18.3478 18.3975 18.1602 18.585C17.9727 18.7726 17.7183 18.8779 17.4531 18.8779H15.4531C8.27313 18.8779 2.45312 13.0579 2.45312 5.87793V3.87793Z",
  fill: "#C81E1E"
});

function SvgPhone({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, phone_ref);
}

/* harmony default export */ var phone = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMi40NTMxMiAzLjg3NzkzQzIuNDUzMTIgMy42MTI3MSAyLjU1ODQ4IDMuMzU4MzYgMi43NDYwMiAzLjE3MDgyQzIuOTMzNTUgMi45ODMyOSAzLjE4NzkxIDIuODc3OTMgMy40NTMxMiAyLjg3NzkzSDUuNjA2MTJDNS44NDI4MyAyLjg3ODA0IDYuMDcxODIgMi45NjIxMSA2LjI1MjM3IDMuMTE1MTlDNi40MzI5MSAzLjI2ODI3IDYuNTUzMzEgMy40ODA0MyA2LjU5MjEyIDMuNzEzOTNMNy4zMzIxMyA4LjE0ODkzQzcuMzY3NDggOC4zNjAxNSA3LjMzNDEgOC41NzcxNCA3LjIzNjg5IDguNzY3OTZDNy4xMzk2OCA4Ljk1ODc4IDYuOTgzNzcgOS4xMTMzNiA2Ljc5MjEzIDkuMjA4OTNMNS4yNDQxMiA5Ljk4MTkzQzUuNzk5MjMgMTEuMzU3NiA2LjYyNTk2IDEyLjYwNzIgNy42NzQ5IDEzLjY1NjJDOC43MjM4NCAxNC43MDUxIDkuOTczNDcgMTUuNTMxOCAxMS4zNDkxIDE2LjA4NjlMMTIuMTIzMSAxNC41Mzg5QzEyLjIxODYgMTQuMzQ3NSAxMi4zNzMxIDE0LjE5MTcgMTIuNTYzNyAxNC4wOTQ1QzEyLjc1NDMgMTMuOTk3MyAxMi45NzExIDEzLjk2MzggMTMuMTgyMSAxMy45OTg5TDE3LjYxNzEgMTQuNzM4OUMxNy44NTA2IDE0Ljc3NzcgMTguMDYyOCAxNC44OTgxIDE4LjIxNTkgMTUuMDc4N0MxOC4zNjg5IDE1LjI1OTIgMTguNDUzIDE1LjQ4ODIgMTguNDUzMSAxNS43MjQ5VjE3Ljg3NzlDMTguNDUzMSAxOC4xNDMxIDE4LjM0NzggMTguMzk3NSAxOC4xNjAyIDE4LjU4NUMxNy45NzI3IDE4Ljc3MjYgMTcuNzE4MyAxOC44Nzc5IDE3LjQ1MzEgMTguODc3OUgxNS40NTMxQzguMjczMTMgMTguODc3OSAyLjQ1MzEyIDEzLjA1NzkgMi40NTMxMiA1Ljg3NzkzVjMuODc3OTNaIiBmaWxsPSIjQzgxRTFFIi8+Cjwvc3ZnPgo=");

;// CONCATENATED MODULE: ./src/modules/DveriContacts/assets/worktime.svg
function worktime_extends() { worktime_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return worktime_extends.apply(this, arguments); }



var worktime_ref = /*#__PURE__*/react.createElement("path", {
  d: "M12.4531 22.3779C10.4753 22.3779 8.54192 21.7914 6.89743 20.6926C5.25294 19.5938 3.97121 18.032 3.21433 16.2048C2.45746 14.3775 2.25942 12.3668 2.64528 10.427C3.03113 8.48722 3.98354 6.70539 5.38206 5.30687C6.78059 3.90834 8.56242 2.95593 10.5022 2.57008C12.442 2.18423 14.4527 2.38226 16.28 3.13914C18.1072 3.89602 19.669 5.17774 20.7678 6.82223C21.8666 8.46672 22.4531 10.4001 22.4531 12.3779C22.4502 15.0292 21.3957 17.5711 19.521 19.4458C17.6462 21.3205 15.1044 22.375 12.4531 22.3779ZM12.4531 4.37793C10.8709 4.37793 9.32416 4.84713 8.00857 5.72618C6.69297 6.60523 5.66759 7.85466 5.06209 9.31647C4.45659 10.7783 4.29817 12.3868 4.60685 13.9387C4.91553 15.4905 5.67745 16.916 6.79628 18.0348C7.9151 19.1536 9.34056 19.9155 10.8924 20.2242C12.4443 20.5329 14.0528 20.3745 15.5146 19.769C16.9764 19.1635 18.2258 18.1381 19.1049 16.8225C19.9839 15.5069 20.4531 13.9602 20.4531 12.3779C20.4507 10.2569 19.6071 8.22349 18.1074 6.72371C16.6076 5.22394 14.5741 4.38032 12.4531 4.37793Z",
  fill: "#C81E1E"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M12.4531 13.3779C12.1879 13.3779 11.9336 13.2726 11.746 13.085C11.5585 12.8975 11.4531 12.6432 11.4531 12.3779V8.37793C11.4531 8.11272 11.5585 7.85836 11.746 7.67083C11.9336 7.48329 12.1879 7.37793 12.4531 7.37793C12.7183 7.37793 12.9727 7.48329 13.1602 7.67083C13.3478 7.85836 13.4531 8.11272 13.4531 8.37793V12.3779C13.4531 12.6432 13.3478 12.8975 13.1602 13.085C12.9727 13.2726 12.7183 13.3779 12.4531 13.3779Z",
  fill: "#C81E1E"
});

var _ref3 = /*#__PURE__*/react.createElement("path", {
  d: "M15.7281 16.6529C15.4629 16.6529 15.2086 16.5475 15.0211 16.3599L11.746 13.085C11.5639 12.8964 11.4632 12.6437 11.4655 12.3815C11.4677 12.1193 11.5729 11.8685 11.7583 11.6831C11.9437 11.4977 12.1945 11.3925 12.4567 11.3903C12.7189 11.388 12.9715 11.4888 13.1601 11.6709L16.4351 14.9459C16.5749 15.0858 16.6701 15.2639 16.7087 15.4579C16.7473 15.6519 16.7275 15.8529 16.6518 16.0356C16.5761 16.2183 16.448 16.3745 16.2836 16.4843C16.1192 16.5942 15.9259 16.6529 15.7281 16.6529Z",
  fill: "#C81E1E"
});

function SvgWorktime({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", worktime_extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, worktime_ref, _ref2, _ref3);
}

/* harmony default export */ var worktime = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/modules/DveriContacts/assets/map.jpg
/* harmony default export */ var map = ("/_next/static/images/map-f88b18b3a7d07eb82c116fae0b5205fd.jpg");
;// CONCATENATED MODULE: ./src/modules/DveriContacts/DveriContacts.tsx













const DveriContacts = () => {
  const page = (0,useCurrentPage/* useCurrentPage */.W)();
  if (!page) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DveriContacts_Component, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Left, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LeftInner, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DveriContacts_Title, {
            children: page.title
          }), page.templateFields.address && /*#__PURE__*/(0,jsx_runtime.jsx)(Address, {
            children: (0,web_core_esm.nl2br)(page.templateFields.address)
          }), page.templateFields.email && /*#__PURE__*/(0,jsx_runtime.jsx)(Param, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ParamLink, {
              href: `mailto:${page.templateFields.email}`,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgEmail, {}), page.templateFields.email]
            })
          }), page.templateFields.phone ? /*#__PURE__*/(0,jsx_runtime.jsx)(Param, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ParamLink, {
              href: `tel:${(0,common/* normalizePhoneNumber */.XL)(page.templateFields.phone)}`,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgPhone, {}), page.templateFields.phone]
            })
          }) : null, page.templateFields.phoneSecond ? /*#__PURE__*/(0,jsx_runtime.jsx)(Param, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ParamLink, {
              href: `tel:${(0,common/* normalizePhoneNumber */.XL)(page.templateFields.phoneSecond)}`,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgPhone, {}), page.templateFields.phoneSecond]
            })
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgWorktime, {}), page.templateFields.workTime]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Right, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DveriContacts_Title, {
          children: page.templateFields.mapTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: map,
          alt: ""
        })]
      })]
    })
  });
};

const DveriContacts_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriContacts__Component",
  componentId: "sc-kvrhga-0"
})(["margin:15px 0;display:flex;flex-direction:column;gap:30px;"]);
const Left = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriContacts__Left",
  componentId: "sc-kvrhga-1"
})(["display:flex;flex-direction:column;gap:40px;flex:1;img{height:auto;}"]);
const Right = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriContacts__Right",
  componentId: "sc-kvrhga-2"
})(["flex:1;"]);
const LeftInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriContacts__LeftInner",
  componentId: "sc-kvrhga-3"
})([""]);
const DveriContacts_Title = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "DveriContacts__Title",
  componentId: "sc-kvrhga-4"
})(["font-size:24px;"]);
const Address = styled_components_browser_esm["default"].p.withConfig({
  displayName: "DveriContacts__Address",
  componentId: "sc-kvrhga-5"
})(["display:block;margin-top:30px;font-size:16px;line-height:32px;margin-bottom:20px;"]);
const Param = styled_components_browser_esm["default"].span.withConfig({
  displayName: "DveriContacts__Param",
  componentId: "sc-kvrhga-6"
})(["display:flex;margin-top:20px;align-items:center;gap:10px;a{display:inline-flex;}"]);
const ParamLink = styled_components_browser_esm["default"].a.withConfig({
  displayName: "DveriContacts__ParamLink",
  componentId: "sc-kvrhga-7"
})(["display:inline-flex;align-items:center;gap:10px;&:hover{opacity:0.7;}"]);
const Buttons = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DveriContacts__Buttons",
  componentId: "sc-kvrhga-8"
})(["margin-top:30px;"]);
/* harmony default export */ var DveriContacts_DveriContacts = (DveriContacts);
;// CONCATENATED MODULE: ./src/modules/DveriContacts/index.ts

;// CONCATENATED MODULE: ./src/services/pageModules.ts








const DEFAULT_PAGE_MODULE = {
  component: modules_DefaultTemplate,
  template: ''
};
const PAGE_MODULE_LIST = [{
  component: Home_Home,
  template: 'belmebel:home'
}, {
  component: Contacts_Contacts,
  template: 'belmebel:contacts'
}, {
  component: FAQ,
  template: 'belmebel:faq'
}, {
  component: Payment_Payment,
  template: 'belmebel:payment'
}, {
  component: Dostavka_Dostavka,
  template: 'belmebel:delivery'
}, {
  component: Rassrochka_Rassrochka,
  template: 'belmebel:rassrochka'
}, {
  template: 'dveri:contacts',
  component: DveriContacts_DveriContacts
}];
function getPageModuleByTemplate(template) {
  var _PAGE_MODULE_LIST$fin;

  return (_PAGE_MODULE_LIST$fin = PAGE_MODULE_LIST.find(pageModule => pageModule.template === template)) !== null && _PAGE_MODULE_LIST$fin !== void 0 ? _PAGE_MODULE_LIST$fin : DEFAULT_PAGE_MODULE;
}
// EXTERNAL MODULE: ./src/utils/thunks.ts
var thunks = __webpack_require__(26625);
;// CONCATENATED MODULE: ./src/pages/[[...slug]].tsx


function _slug_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _slug_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _slug_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _slug_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















function DynamicPage(props) {
  const page = (0,hooks/* useLayoutPage */.JP)();
  const router = (0,next_router.useRouter)();
  const currentPath = router.basePath && router.basePath !== '/' ? router.basePath + router.asPath : router.asPath;
  const canonicalUrl = "https://dverione.com.ua" + currentPath;

  if (props.pageType === 'NOT_FOUND') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
  }

  if (props.pageType === 'ERROR') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _slug_objectSpread({}, (0,common/* convertErrorToProps */.g1)(props.error)));
  }

  const foundPageModule = getPageModuleByTemplate(props.template);
  const pageElement = /*#__PURE__*/react.createElement(foundPageModule.component);
  const seoPageProps = (0,web_modules_esm/* convertSeoParamsToPageProps */.gm)(page === null || page === void 0 ? void 0 : page.seoParams);

  if (seoPageProps.openGraphImage == null && page !== null && page !== void 0 && page.image) {
    seoPageProps.openGraphImage = page.image.url;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, _slug_objectSpread(_slug_objectSpread({}, seoPageProps), {}, {
    canonicalUrl: canonicalUrl,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: pageElement
    })
  }));
}

DynamicPage.getInitialProps = async context => {
  const {
    store,
    query
  } = context;
  const currentPath = (0,common/* convertSlugToPath */.L1)(query.slug);

  try {
    await Promise.all([...(0,thunks/* getSharedThunkList */.q)(store.dispatch)]);
    const pageList = await store.dispatch((0,pages/* getPageListThunk */.NI)());
    const foundPage = pageList.find(page => page.path === currentPath);
    const foundPageModule = getPageModuleByTemplate(foundPage === null || foundPage === void 0 ? void 0 : foundPage.template);

    if (!foundPage) {
      if (context.res) {
        context.res.statusCode = 404;
      }

      return {
        pageType: 'NOT_FOUND'
      };
    }

    await Promise.all([store.dispatch((0,blog/* getBlogCategoryListThunk */.ao)()), store.dispatch((0,pages/* getPageByPathThunk */.fM)(foundPage.path)), foundPageModule.getInitialProps ? foundPageModule.getInitialProps(context) : Promise.resolve()]);
    return {
      pageType: 'DYNAMIC_PAGE',
      template: foundPageModule.template
    };
  } catch (error) {
    return {
      pageType: 'ERROR',
      error
    };
  }
};

/* harmony default export */ var _slug_ = (DynamicPage);

/***/ }),

/***/ 28150:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(23935);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [741,989,901,235,880,693,774,888,179], function() { return __webpack_exec__(28150); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);